/* eslint-disable import/prefer-default-export */
import { put } from 'redux-saga/effects';
import { setVersion } from '@/store/actions/runtime';

export const versionSaga = ({ version }) => function* saga() {
  yield put(setVersion(version));
};
